var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"family-member"},[_c('Button',{attrs:{"classes":"add-person-circle","onClick":_vm.addNewPerson,"type":"button"}},[_vm._v(" ")]),_c('div',{staticClass:"add-family-member text-uppercase"},[_vm._v("Add dependent")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }